module.exports = __webpack_public_path__ + "static/img/sindex_banner1.0e0a126.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sindex_banner1.jpg
// module id = XB8e
// module chunks = 1